import { useEffect, useState } from "react";
import api, { JURISDICTION_LEVELS, COUNTRIES } from "@/lib/api";

// Module-level cache so the public config is fetched only once across the app.
let cached = null;
let inflight = null;

export function usePublicConfig() {
  const [config, setConfig] = useState(cached);
  useEffect(() => {
    if (cached) return;
    if (!inflight) {
      inflight = api.get("/config/public").then((r) => { cached = r.data; return r.data; }).catch(() => ({}));
    }
    let active = true;
    inflight.then((d) => { if (active) setConfig(d); });
    return () => { active = false; };
  }, []);
  return config || {};
}

// International coverage can be paused server-side (INTERNATIONAL_ENABLED); hidden until config says otherwise.
export function useCoverage() {
  const intl = usePublicConfig().international_enabled === true;
  return {
    intl,
    levels: intl ? JURISDICTION_LEVELS : JURISDICTION_LEVELS.filter((l) => l !== "international"),
    countries: intl ? COUNTRIES : [],
  };
}
